
<template>
    
        <div class="law-card-wrapper law-ads-container"><div v-html="htmls"></div><script v-if="tagId" :id="tagId" type="text/html">
        <div class="relative-ads-case-item">
            <%:=ad_place_data%>
            <style type="text/css">
                <%:=ad_place_css%>
            </style>
            <script>
                <%:=ad_place_js%>
            </script></div>
    
</template>

<script>
/* globals getApp, Page, swan */

export default {
  name: '',
  components: {},
  props: {
    adsEid: {
      type: Number,
      default: 0
    },
    adsH5ChangeItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      htmls: '',
      tagId: ''
    };
  },
  mounted() {
    this.tagId = 'case-list-item-' + this.randomString(5);
    this.$nextTick(() => {
      const bt = window.baidu.template;
      const html = bt && bt(this.tagId, this.adsH5ChangeItem) || '';
      this.htmls = html;
    });
  },
  methods: {
    randomString(len) {
      len = len || 32;
      const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      const maxPos = $chars.length;
      let pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    }
  }
};
</script>

<style scoped>
.law-ads-container {
  padding-left: 12px;
  padding-right: 12px;
  background: #fff;
}

</style>
